const MyAccountIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2001C9.5 19.2001 7.29 17.9201 6 15.9801C6.03 13.9901 10 12.9001 12 12.9001C13.99 12.9001 17.97 13.9901 18 15.9801C16.71 17.9201 14.5 19.2001 12 19.2001Z"
        fill="#5F738C"
      />
    </svg>
  );
};

export { MyAccountIcon };
